import type { WhiteboardDto, WhiteboardSummaryDto } from '../types';

/**
 * Mock data for `VITE_USE_MOCK` mode.
 *
 * @remarks
 * `snapshot` is null on every entry on purpose: a real Yjs snapshot is opaque binary that
 * can't be hand-written, and null is a valid production state (a whiteboard that has never
 * been compacted). Mock mode therefore renders an empty canvas, which is the correct
 * end-to-end behaviour for a document with no updates.
 */
export const mockWhiteboards: WhiteboardSummaryDto[] = [
  {
    id: 'wb-1',
    boardId: 'board-1',
    name: 'Lluvia de ideas — Rediseño de onboarding',
    createdById: 'user-1',
    createdBy: 'Guillermo Sandoval',
    createdAt: '2026-08-24T14:00:00Z',
    updatedAt: '2026-08-31T18:42:00Z',
    activeEditorCount: 2,
  },
  {
    id: 'wb-2',
    boardId: 'board-1',
    name: 'Mapa del flujo de invitaciones',
    createdById: 'user-2',
    createdBy: 'Laura Álvarez',
    createdAt: '2026-08-19T09:15:00Z',
    updatedAt: '2026-08-27T11:05:00Z',
    activeEditorCount: 0,
  },
  {
    id: 'wb-3',
    boardId: 'board-1',
    name: 'Retro sprint 14',
    createdById: 'user-3',
    createdBy: 'Mariana Estrada',
    createdAt: '2026-08-05T16:30:00Z',
    updatedAt: '2026-08-06T10:20:00Z',
    activeEditorCount: 0,
  },
];

export const mockWhiteboardDetail: WhiteboardDto = {
  id: 'wb-1',
  boardId: 'board-1',
  name: 'Lluvia de ideas — Rediseño de onboarding',
  snapshot: null,
  snapshotSeq: 0,
  lastSeq: 0,
  canEdit: true,
  createdAt: '2026-08-24T14:00:00Z',
  updatedAt: '2026-08-31T18:42:00Z',
};
